import { render, staticRenderFns } from "./VocabularyTermModal.vue?vue&type=template&id=e4de2ece&scoped=true&"
import script from "./VocabularyTermModal.vue?vue&type=script&lang=js&"
export * from "./VocabularyTermModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4de2ece",
  null
  
)

export default component.exports